var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { plainToClass, plainToClassFromExist } from 'class-transformer';
import { $ } from '../../simpli';
/**
 * The Response is an auxiliary class of [[Request]].
 *
 * Although you may use this class to make HTTP requests, it is recommended to use [[Request]] instead.
 *
 * By using [[Request]], the code will be semantically better.
 *
 * It uses [Axios](https://github.com/axios/axios) to request; therefore, you may configure an Axios instance.
 *
 * ## Example of configuration
 * ```typescript
 * import Simpli from 'simpli-web-sdk'
 * import axios from 'axios'
 *
 * const axiosInstance = axios.create({
 *  baseURL: 'http://example.com/api'
 * })
 *
 * Simpli.axios = axiosInstance
 *
 * Simpli.install()
 * ```
 *
 * ## Example
 * ```typescript
 * import {Request, Response} from 'simpli-web-sdk'
 * import {User} from './User'
 *
 * async function example() {
 *   const request = new Request({url: '/path/to/url', method: 'GET'})
 *   const response = new Response(request, User)
 *   return await response.getData() // User type
 * }
 * ```
 */
var Response = /** @class */ (function () {
    /**
     * Assigns a new response instance with a provided request instance.
     *
     * ```typescript
     * import {Request, Response} from 'simpli-web-sdk'
     *
     * async function example() {
     *   const request = new Request({url: '/path/to/url', method: 'GET'})
     *   const response = new Response(request, User)
     * }
     * ```
     * @param request A request instance
     * @param responseType The response type. You may use either an instance object or a class definition.
     * If it is an instance, then the response will populate it.
     */
    function Response(request, responseType) {
        this.request = request;
        this.responseType = responseType;
    }
    Object.defineProperty(Response.prototype, "axiosConfig", {
        /**
         * Get the Axios configuration of the provided [[Request]].
         * More details in [Axios Docs](https://github.com/axios/axios#request-config)
         * @hidden
         */
        get: function () {
            return this.request.axiosConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "requestName", {
        /**
         * Get the name of the provided [[Request]].
         * @hidden
         */
        get: function () {
            return this.request.requestName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "requestDelay", {
        /**
         * Get the delay of the provided [[Request]].
         * @hidden
         */
        get: function () {
            return this.request.requestDelay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "endpoint", {
        /**
         * Get the endpoint of the provided [[Request]].
         * @hidden
         */
        get: function () {
            return this.request.endpoint;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gives a name of this request which is used in [[Await]] component.
     *
     * The same effect of [request.name()](./request.html#name)
     */
    Response.prototype.name = function (requestName) {
        this.request.requestName = requestName;
        return this;
    };
    /**
     * Provides a delay of any request from this instance.
     *
     * The same effect of [request.delay()](./request.html#delay)
     */
    Response.prototype.delay = function (requestDelay) {
        this.request.requestDelay = Math.max(requestDelay, 0);
        return this;
    };
    /**
     * Makes a HTTP request and returns the data content from response.
     *
     * ```typescript
     * import {Request} from 'simpli-web-sdk'
     *
     * async function example1() {
     *   return await Request.get('/path/to/url')
     *     .asAny()
     *     .getData()
     * }
     *
     * // the same of
     *
     * async function example2() {
     *   const resp = await Request.get('/path/to/url')
     *     .asAny()
     *     .getResponse()
     *   return resp.data
     * }
     * ```
     */
    Response.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse()];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    /**
     * Makes a HTTP request and returns the response content.
     *
     * ```typescript
     * import {Request} from 'simpli-web-sdk'
     *
     * async function example() {
     *   return await Request.get('/path/to/url')
     *     .asAny()
     *     .getResponse()
     * }
     * ```
     */
    Response.prototype.getResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, axiosConfig, responseType, requestName, requestDelay, endpoint, event, request, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, axiosConfig = _a.axiosConfig, responseType = _a.responseType, requestName = _a.requestName, requestDelay = _a.requestDelay, endpoint = _a.endpoint;
                        event = responseType;
                        if (event && typeof event.onBeforeResponse === 'function') {
                            event.onBeforeResponse(this);
                        }
                        request = function () { return $.axios.request(axiosConfig); };
                        return [4 /*yield*/, $.await.run(requestName || endpoint, request, requestDelay)];
                    case 1:
                        response = _b.sent();
                        if (event && typeof event.onBeforeSerialization === 'function') {
                            event.onBeforeSerialization(response, this);
                        }
                        if (response.data === undefined) {
                            response.data = JSON.parse(response.request.response || '{}');
                        }
                        if (responseType === undefined) {
                            return [2 /*return*/, response];
                        }
                        if (typeof responseType === 'object') {
                            // Class object instance from constructor (new CustomClass())
                            // The instance will be automatically populated
                            response.data = plainToClassFromExist(responseType, response.data);
                        }
                        else if (typeof responseType === 'function') {
                            // Class constructor (CustomClass, Number, String, Boolean, etc.)
                            response.data = plainToClass(responseType, response.data);
                        }
                        else
                            throw Error('Error: Entity should be either a Class or ClassObject');
                        if (event && typeof event.onAfterSerialization === 'function') {
                            event.onAfterSerialization(response, this);
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return Response;
}());
export { Response };
//# sourceMappingURL=Response.js.map